import MenuItem from '@mui/material/MenuItem'
import * as countryFlagComponents from 'country-flag-icons/react/3x2'
import {
  CountryCodeContainer,
  CountryFlagStyle,
  PhoneLocalMenuItemContainer
} from './PhoneNumberInput.style'

export const PhoneNumberInputOption = (props: any) => {
  const countryCode = props['data-value']
  const FlagImage =
    countryFlagComponents[countryCode as keyof typeof countryFlagComponents]
  return (
    <MenuItem
      {...props}
      key={countryCode}
      value={countryCode}
      style={{ padding: 0 }}
    >
      <PhoneLocalMenuItemContainer variant={'MENU_ITEM'}>
        <FlagImage style={CountryFlagStyle} />
        <CountryCodeContainer>{countryCode}</CountryCodeContainer>
      </PhoneLocalMenuItemContainer>
    </MenuItem>
  )
}

interface PhoneNumberInputFlagImageProps {
  countryCode: string
}

export const PhoneNumberInputFlagImage = ({
  countryCode
}: PhoneNumberInputFlagImageProps) => {
  const FlagImage =
    countryFlagComponents[countryCode as keyof typeof countryFlagComponents]
  return <FlagImage style={CountryFlagStyle} />
}
